import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import Layout from '../layout-tank/layout'
import AddAsset from '../assets/asset-mangament/create-asset/asset-modal.component'
import styles from './device-management.module.css'
import ConfigureDevice from '../configuration-templates/configuration-modal-component'
import AssetView, {
  AssetViewContext,
} from '../assets/asset-info-view/assetView'
import SpeedDials from '../assets/asset-mangament/assets-actions'
import { DEVICE_STATUS_ENUM } from '../../../services/device'
import ProvisionConfirmDialog from '../assets/asset-provision/confirm-dialog'
import DeviceBulkUpload from '../bulk-upload/bulkUpload.componant'
import DeviceList from '../assets/asset-list/assetList.component'

export default function TankDeviceManagement() {
  const [viewAsset, setViewAsset] = useState(false)
  const [assetData, setAssetData] = useState(false)
  const [show, setShow] = useState(false)
  const [openTemplateDialog, setOpenTemplateDialog] = useState(false)
  const [showConfirmDialog, setShowConfirmDialog] = useState(false)
  const [showDeviceBulk, setDeviceBulkShow] = useState(false)

  const { userRole } = useSelector((store) => ({
    userRole: store.auth.userRole,
  }))

  useEffect(() => {
    setViewAsset(false)
  }, [])

  return (
    <Layout>
      <AssetViewContext.Provider
        value={{
          viewAsset,
          setViewAsset,
          assetData,
          setAssetData,
          openTemplateDialog,
          showDeviceBulk,
          setDeviceBulkShow,
          setOpenTemplateDialog,
          showConfirmDialog,
          setShowConfirmDialog,
        }}
      >
        <div className={styles.container}>
          {viewAsset ? (
            <AssetView />
          ) : (
            <>
              <DeviceList
                className={styles.list}
                status={DEVICE_STATUS_ENUM.ALL}
              />
              {userRole === 'ADMIN' ||
              userRole === 'PARTNER' ||
              userRole === 'CUSTOMER' ? (
                <>
                  <SpeedDials
                    show={show}
                    setShow={setShow}
                    showDeviceBulk={showDeviceBulk}
                    setDeviceBulkShow={setDeviceBulkShow}
                  />
                  <AddAsset
                    show={show}
                    setShow={setShow}
                    className={styles.actions}
                  />
                </>
              ) : null}
              <ConfigureDevice />
              <ProvisionConfirmDialog
                showConfirmDialog={showConfirmDialog}
                setShowConfirmDialog={setShowConfirmDialog}
                device={assetData}
              />
              <DeviceBulkUpload
                showDeviceBulk={showDeviceBulk}
                setDeviceBulkShow={setDeviceBulkShow}
              />
            </>
          )}
        </div>
      </AssetViewContext.Provider>
    </Layout>
  )
}
